import { badgeInvoiceVariants } from '@/components/ui/StatusBadge/StatusBadgeInvoice';
import { StateInvoice } from '@/interfaces';
import { VariantProps } from 'class-variance-authority';

export const stateToVariantInvoice: Record<
	StateInvoice,
	VariantProps<typeof badgeInvoiceVariants>['variant']
> = {
	[StateInvoice.FACTURADA]: 'Facturada',
	[StateInvoice.CANCELADA]: 'Cancelada',
	[StateInvoice.PENDIENTE]: 'Pendiente',
	[StateInvoice.RECHAZADA]: 'Rechazada',
	[StateInvoice.DESCONOCIDO]: 'Desconocido',
	[StateInvoice.PAGADA]: 'Pagada',
};
